const getPageTitle = (isMdt = false) => {
  // TODO: internationalize this

  if (isMdt) {
    return 'Master Dealer Tool';
  }

  return 'Revendedor Chama';
};

export default getPageTitle;



// WEBPACK FOOTER //
// ../utils/functions/get-page-title.js